import { AxiosInstance } from 'axios';

import { insertId } from '../../insertId';
import { cancellable } from '../../cancellable';

export interface ITargetCheckRun {
  createdOn?: string;
  status: string;
  displayMessage: string;
}

const toResponse = (response: any): ITargetCheckRun => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }
  const { createdOn, status, displayMessage } = response.result;
  return {
    createdOn: createdOn ? createdOn.replace('T', ' ').replace('Z', '') : '',
    status,
    displayMessage,
  };
};

export default (api: AxiosInstance, url: string) => (id: number) => {
  const urlWithId = insertId(url, id);
  return cancellable<ITargetCheckRun>(
    (cancelOptions: any) => api.post(urlWithId, null, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/link/targetCheck/id.ts